/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GetBaseInfo} from '../models/GetBaseInfo';

export interface CreateMicrosites$Request {
    accountId: number;
    logo: File | File[];
    micrositeName: string;
    domains: Array<string>;
    accountPageInstructions?: string;
    loginPageInstructions?: string;
    loginPasswordPrompt?: string;
    loginUserNamePrompt?: string;
}

export interface CreateMicrosites$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const createMicrositesRequest = createAction<PayloadData<void, CreateMicrosites$Request>>('MICRO_SITES_BASE_INFO__CREATE_MICROSITES__REQUEST');
export const createMicrositesSuccess = createAction<PayloadData<void, CreateMicrosites$Request>>('MICRO_SITES_BASE_INFO__CREATE_MICROSITES__SUCCESS');
export const createMicrositesFailure = createAction<PayloadData<Error, CreateMicrosites$Request, true>>('MICRO_SITES_BASE_INFO__CREATE_MICROSITES__FAILURE');

export const createMicrositesActions = [
    createMicrositesRequest,
    createMicrositesSuccess,
    createMicrositesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {any} meta.logo
 * @param {string} meta.micrositeName
 * @param {Array<string>} meta.domains
 * @param {string} [meta.accountPageInstructions]
 * @param {string} [meta.loginPageInstructions]
 * @param {string} [meta.loginPasswordPrompt]
 * @param {string} [meta.loginUserNamePrompt]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const createMicrosites = (meta: CreateMicrosites$Request, config?: CreateMicrosites$Config) => {
    const TRANSPORT_REQUEST_FILE = {
        logo: meta.logo,
        micrositeName: meta.micrositeName,
        domains: meta.domains,
        accountPageInstructions: meta.accountPageInstructions,
        loginPageInstructions: meta.loginPageInstructions,
        loginPasswordPrompt: meta.loginPasswordPrompt,
        loginUserNamePrompt: meta.loginUserNamePrompt,
    };
    return {
        UPLOAD_FILE: {
            types: createMicrositesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites`,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteMicrosite$Request {
    accountId: number;
}

export interface DeleteMicrosite$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteMicrositeRequest = createAction<PayloadData<void, DeleteMicrosite$Request>>('MICRO_SITES_BASE_INFO__DELETE_MICROSITE__REQUEST');
export const deleteMicrositeSuccess = createAction<PayloadData<void, DeleteMicrosite$Request>>('MICRO_SITES_BASE_INFO__DELETE_MICROSITE__SUCCESS');
export const deleteMicrositeFailure = createAction<PayloadData<Error, DeleteMicrosite$Request, true>>('MICRO_SITES_BASE_INFO__DELETE_MICROSITE__FAILURE');

export const deleteMicrositeActions = [
    deleteMicrositeRequest,
    deleteMicrositeSuccess,
    deleteMicrositeFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteMicrosite = (meta: DeleteMicrosite$Request, config?: DeleteMicrosite$Config) => {
    return {
        CALL_API: {
            types: deleteMicrositeActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetMicrositesBaseInfo$Request {
    accountId: number;
}

export interface GetMicrositesBaseInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMicrositesBaseInfoRequest = createAction<PayloadData<void, GetMicrositesBaseInfo$Request>>('MICRO_SITES_BASE_INFO__GET_MICROSITES_BASE_INFO__REQUEST');
export const getMicrositesBaseInfoSuccess = createAction<PayloadData<GetBaseInfo, GetMicrositesBaseInfo$Request>>('MICRO_SITES_BASE_INFO__GET_MICROSITES_BASE_INFO__SUCCESS');
export const getMicrositesBaseInfoFailure = createAction<PayloadData<Error, GetMicrositesBaseInfo$Request, true>>('MICRO_SITES_BASE_INFO__GET_MICROSITES_BASE_INFO__FAILURE');

export const getMicrositesBaseInfoActions = [
    getMicrositesBaseInfoRequest,
    getMicrositesBaseInfoSuccess,
    getMicrositesBaseInfoFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMicrositesBaseInfo = (meta: GetMicrositesBaseInfo$Request, config?: GetMicrositesBaseInfo$Config) => {
    return {
        CALL_API: {
            types: getMicrositesBaseInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateMicrosites$Request {
    accountId: number;
    micrositeName: string;
    domains: Array<string>;
    accountPageInstructions: string;
    loginPageInstructions: string;
    loginPasswordPrompt: string;
    loginUserNamePrompt: string;
    body: string;
}

export interface UpdateMicrosites$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateMicrositesRequest = createAction<PayloadData<void, UpdateMicrosites$Request>>('MICRO_SITES_BASE_INFO__UPDATE_MICROSITES__REQUEST');
export const updateMicrositesSuccess = createAction<PayloadData<void, UpdateMicrosites$Request>>('MICRO_SITES_BASE_INFO__UPDATE_MICROSITES__SUCCESS');
export const updateMicrositesFailure = createAction<PayloadData<Error, UpdateMicrosites$Request, true>>('MICRO_SITES_BASE_INFO__UPDATE_MICROSITES__FAILURE');

export const updateMicrositesActions = [
    updateMicrositesRequest,
    updateMicrositesSuccess,
    updateMicrositesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} meta.micrositeName
 * @param {Array<string>} meta.domains
 * @param {string} meta.accountPageInstructions
 * @param {string} meta.loginPageInstructions
 * @param {string} meta.loginPasswordPrompt
 * @param {string} meta.loginUserNamePrompt
 * @param {string} meta.body
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateMicrosites = (meta: UpdateMicrosites$Request, config?: UpdateMicrosites$Config) => {
    const TRANSPORT_GET_PARAMS = {
        micrositeName: meta.micrositeName,
        domains: meta.domains,
        accountPageInstructions: meta.accountPageInstructions,
        loginPageInstructions: meta.loginPageInstructions,
        loginPasswordPrompt: meta.loginPasswordPrompt,
        loginUserNamePrompt: meta.loginUserNamePrompt,
    };
    return {
        CALL_API: {
            types: updateMicrositesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.body,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ValidateMicrositeHost$Request {
    host: string;
}

export interface ValidateMicrositeHost$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateMicrositeHostRequest = createAction<PayloadData<void, ValidateMicrositeHost$Request>>('MICRO_SITES_BASE_INFO__VALIDATE_MICROSITE_HOST__REQUEST');
export const validateMicrositeHostSuccess = createAction<PayloadData<void, ValidateMicrositeHost$Request>>('MICRO_SITES_BASE_INFO__VALIDATE_MICROSITE_HOST__SUCCESS');
export const validateMicrositeHostFailure = createAction<PayloadData<Error, ValidateMicrositeHost$Request, true>>('MICRO_SITES_BASE_INFO__VALIDATE_MICROSITE_HOST__FAILURE');

export const validateMicrositeHostActions = [
    validateMicrositeHostRequest,
    validateMicrositeHostSuccess,
    validateMicrositeHostFailure
] as const;

/**
 * @param {string} meta.host
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateMicrositeHost = (meta: ValidateMicrositeHost$Request, config?: ValidateMicrositeHost$Config) => {
    const TRANSPORT_GET_PARAMS = {
        host: meta.host,
    };
    return {
        CALL_API: {
            types: validateMicrositeHostActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/microsites/host/validate`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

